export default __webpack_public_path__ + "static/media/phone1.78c2a50d.svg";